export default "__VITE_ASSET__BjdtFkxJ__"